window.NewPermissionModal = class NewPermissionModal
  handler_events: ->
    handler_on_change_select()

  handler_on_change_select = () ->
    $(".new-groupcontainer .select").on "change", "#data_access_allowed_data_access_group_id", ->
      $(".list-users").css('display','none')
      $("#list-users-#{$(@).find(':selected').get(0).value}").css('display','block')
